import { useAIHelpContext } from '@context'
import React from 'react'
import toast from 'react-hot-toast'
import { HiSparkles } from 'react-icons/hi2'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'

const HelpLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.8;
  }
`

const LucaHelpToastContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs}rem;
  line-height: 1.4;
`

const LucaHelpToastTitle = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutralBlack};
`

const LucaHelpToastHint = styled.span`
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.metalGray};
`

const LUCA_HELP_TOAST_ID = 'document-help-luca'

export const DocumentHelpLink: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { isAIHelpOpen, setAIHelpOpen } = useAIHelpContext()

  const showLucaHelpToast = () => {
    toast(
      <LucaHelpToastContent>
        <LucaHelpToastTitle>{t('document.helpLucaAlreadyOpenTitle')}</LucaHelpToastTitle>
        <LucaHelpToastHint>{t('document.helpLucaAlreadyOpenHint')}</LucaHelpToastHint>
      </LucaHelpToastContent>,
      {
        id: LUCA_HELP_TOAST_ID,
        icon: <HiSparkles color={theme.colors.AIPurple} size={theme.iconSize.md * 16} />,
        duration: 6000
      }
    )
  }

  const handleClick = () => {
    if (!isAIHelpOpen) setAIHelpOpen(true)
    showLucaHelpToast()
  }

  return (
    <HelpLink type="button" onClick={handleClick}>
      {t('document.helpNeeded')}
    </HelpLink>
  )
}
